import React, { ReactElement } from "react";
import ActualitesComponent from "@/components/Actualites/ActualitesComponent";
import { GENERAL_DATA } from "@/constants/data";

export default function Actualites() {
  return (
    <div>
      <ActualitesComponent
        title={GENERAL_DATA.actualites.title}
        subtitle={GENERAL_DATA.actualites.subtitle}
        description={GENERAL_DATA.actualites.description}
        news={GENERAL_DATA.actualites.news}
      />
    </div>
  );
}
